/* === DOM references ============================================== */
const genderBtns    = document.querySelectorAll('.gender-btn');
const goalBtns      = document.querySelectorAll('.goal-btn');
const sportWrap     = document.getElementById('sportContainer');
const addBtn        = document.getElementById('addSportBtn');
const removeBtn     = document.getElementById('removeSportBtn');
const calcBtn       = document.getElementById('calcBtn');
const editBtn       = document.getElementById('editBtn');
const inputPanel    = document.getElementById('inputPanel');
const resultsPanel  = document.getElementById('resultsPanel');
const collectionBox = document.querySelector('.CollectionEmbed.CollectionMain');
const ncalcRoot     = document.querySelector('.ncalc');
const jobSelect     = document.getElementById('job');

const calculatorI18n = JSON.parse(ncalcRoot?.dataset.calculatorI18n || '{}');
function calcText(key, values = {}) {
  return String(calculatorI18n[key] ?? '').replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
}
function calcEscape(text) {
  return String(text).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
}


/* Extra protein sources appended to the table */
const EXTRA_SOURCES = [
  { name: calcText('chicken'),        p100: 21 },
  { name: calcText('beef'),       p100: 19 },
  { name: calcText('pollock'),      p100: 18 },
  { name: calcText('chickpeas'),      p100: 18 },
  { name: calcText('mozzarella'),                p100: 18 },
  { name: calcText('cottage_cheese'),  p100: 16 },
  { name: calcText('quark'),                p100: 12 },
  { name: calcText('tofu'),                p100: 11 },
  { name: calcText('lentils'),         p100: 6  },
  { name: calcText('kidney_beans'),   p100: 6  }
];

/* Inputs & result cells */
const ageEl    = document.getElementById('age');
const weightEl = document.getElementById('weight');
const heightEl = document.getElementById('height');

const breakfastCell = document.querySelector('#breakfastCell span');
const lunchCell     = document.querySelector('#lunchCell span');
const dinnerCell    = document.querySelector('#dinnerCell span');
const shakesCell    = document.getElementById('shakesCell-count');

/* Initial state */
let gender = document.querySelector('.gender-btn.active')?.dataset.gender || 'w';
let goal   = document.querySelector('.goal-btn.active')  ?.dataset.goal   || 'deficit';

let sportCount        = 0;
const MAX_SPORTS      = 4;
const DEFAULT_SLEEP   = 8;   // hours/day
const DEFAULT_WORK    = 56;  // hours/week

/* ---------- helpers ------------------------------------------------ */
function toggleHoursState(selectEl) {
  const row        = selectEl.closest('.sport-input');
  const hoursInput = row.querySelector('.sport-hours');
  const buttons    = row.querySelectorAll('.counter button');
  const noSport    = !selectEl.value || selectEl.value === '0';

  hoursInput.disabled = noSport;
  hoursInput.value    = noSport ? '0' : (hoursInput.value || '0');
  hoursInput.classList.toggle('is-disabled', noSport);
  buttons.forEach(b => b.disabled = noSport);
}

function scrollToResults(offset = 120){
  const top = resultsPanel.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top, behavior: 'smooth' });
}

/* Clamp numeric inputs to min/max and keep decimals if needed */
function clampInput(input){
  const min  = input.min ? +input.min : -Infinity;
  const max  = input.max ? +input.max :  Infinity;
  let   val  = parseFloat(input.value);
  if (Number.isNaN(val)) return;
  val = Math.min(Math.max(val, min), max);
  const step = parseFloat(input.step) || 1;
  input.value = val.toFixed(step < 1 ? 1 : 0);
}
function debounceClamp(input){
  let t;
  const run = () => { clampInput(input); input.classList.remove('is-invalid'); autoRecalc(); };
  input.addEventListener('input', () => {
    clearTimeout(t);
    input.classList.remove('is-invalid');
  });
  input.addEventListener('change', run);
  input.addEventListener('blur', run);
}
['height','weight','age'].forEach(id => debounceClamp(document.getElementById(id)));

/* Protein table toggler (re-init after each calc) */
function setupProteinToggle(){
  const wrapper = document.querySelector('.source-table__wrapper');
  if (!wrapper) return;

  // Remove old button if exists
  const oldBtn = wrapper.nextElementSibling;
  if (oldBtn && oldBtn.classList?.contains('show-all-btn')) oldBtn.remove();

  wrapper.classList.remove('collapsed');

  const rows = wrapper.querySelectorAll('tbody tr');
  if (rows.length <= 3) return;

  wrapper.classList.add('collapsed');

  const btn = document.createElement('button');
  btn.className = 'show-all-btn';
  btn.textContent = calcText('show_sources');
  wrapper.after(btn);

  btn.addEventListener('click', () => {
    wrapper.classList.remove('collapsed');
    btn.remove();
  });
}

/* Add extra protein rows (called on every calc) */
function renderExtraSources(perMealProt){
  const tbody = document.querySelector('.source-table tbody');
  if (!tbody) return;

  tbody.querySelectorAll('tr[data-extra="1"]').forEach(tr => tr.remove());

  const gramsFor = p100 => Math.ceil((perMealProt / p100) * 100);

  EXTRA_SOURCES.forEach(src => {
    const tr = document.createElement('tr');
    tr.setAttribute('data-extra', '1');
    tr.innerHTML = `
      <td>${calcEscape(src.name)}</td>
      <td>${src.p100} g</td>
      <td>${gramsFor(src.p100)} g</td>
    `;
    tbody.appendChild(tr);
  });
}

/* Sport rows */
function addSportRow(initial = false){
  if (sportCount >= MAX_SPORTS) return;
  sportCount++;

  const labelTxt = sportCount === 1
    ? calcText('sport_question')
    : calcText('another_sport');

  const row = document.createElement('div');
  row.className = 'sport-input';

  const placeholderOpt  = `<option value="" disabled selected>${calcEscape(calcText('select_sport'))}</option>`;
  const keinSportOpt    = `<option value="0">${calcEscape(calcText('no_sport'))}</option>`;
  const defaultSelected = initial ? ' selected' : '';

  row.innerHTML = `
    <div>
      <label>${calcEscape(labelTxt)}</label>
      <select class="sport-met" data-placeholder="${calcEscape(calcText('select_sport'))}">
        ${placeholderOpt}
        ${keinSportOpt}
        <option value="2.5">${calcEscape(calcText('sport_relaxed'))}</option>
        <option value="3.5"${defaultSelected}>${calcEscape(calcText('sport_moderate_strength'))}</option>
        <option value="6">${calcEscape(calcText('sport_intense_strength'))}</option>
        <option value="7.5">${calcEscape(calcText('sport_ball'))}</option>
        <option value="8">${calcEscape(calcText('sport_moderate_cardio'))}</option>
        <option value="12">${calcEscape(calcText('sport_intense_cardio'))}</option>
      </select>
    </div>
    <div>
      <label>${calcEscape(calcText('hours_week'))}</label>
      <div class="counter">
        <button type="button" class="dec">−</button>
        <input type="number" class="sport-hours" value="${initial ? 2 : 0}" step="0.5" min="0" max="20" placeholder="${calcEscape(calcText('hours'))}" required>
        <button type="button" class="inc">+</button>
      </div>
    </div>`;

  sportWrap.appendChild(row);

  const select = row.querySelector('.sport-met');
  NiceSelect.bind(select, { searchable: false, placeholder: calcText('select_sport') });

  toggleHoursState(select);

  select.addEventListener('change', () => {
    if (!select.value) select.value = '0';
    toggleHoursState(select);
    autoRecalc();
  });

  const hoursInp = row.querySelector('.sport-hours');
  debounceClamp(hoursInp);

  row.querySelector('select').addEventListener('change', autoRecalc);

  toggleRowButtons();
}
function changeHours(inp, delta){
  if (inp.disabled) return;
  const step  = +inp.step || 0.5;
  const min   = +inp.min  || 0;
  const max   = +inp.max  || 20;
  let   v     = parseFloat(inp.value) || 0;
  v = Math.round((v + delta) / step) * step;
  inp.value = Math.min(Math.max(v, min), max).toFixed(step < 1 ? 1 : 0);
  autoRecalc();
}
function removeSportRow(){
  if (sportCount <= 1) return;
  sportWrap.lastElementChild.remove();
  sportCount--;
  sportWrap.querySelectorAll('.sport-input > div:first-child > label')
           .forEach(l => l.textContent = calcText('another_sport'));
  toggleRowButtons();
  autoRecalc();
}
function toggleRowButtons(){
  addBtn.style.display    = sportCount >= MAX_SPORTS ? 'none'  : 'block';
  removeBtn.style.display = sportCount >= 2          ? 'block' : 'none';
}

/* Validation */
function validateRequired(){
  let first = null;
  document.querySelectorAll('input[required]').forEach(i=>{
    const empty = !i.value.trim();
    i.classList.toggle('is-invalid', empty);
    if (empty && !first) first = i;
  });
  if (first) first.focus();
  return !first;
}

/* Panel switch */
function togglePanels(){
  const willShowResults = resultsPanel.classList.contains('hidden');

  inputPanel.classList.toggle('hidden');
  resultsPanel.classList.toggle('hidden');
  toggleCollection(willShowResults);
  if (ncalcRoot) ncalcRoot.classList.toggle('active', willShowResults);

  if (willShowResults) {
    requestAnimationFrame(scrollToResults);
  }
}

/* Auto recalc when results visible */
function autoRecalc(){
  if (!resultsPanel.classList.contains('hidden')) calculate();
}

/* Main calculation */
function calculate(){
  // clamp inputs
  ['height','weight','age'].forEach(id => clampInput(document.getElementById(id)));

  // base data
  const age    = +ageEl.value;
  const weight = +weightEl.value;
  const height = +heightEl.value;
  const jobMET = +jobSelect.value;
  const workH  = DEFAULT_WORK;

  // sports
  let sportH = 0, sportMETxH = 0;
  sportWrap.querySelectorAll('.sport-input').forEach(row => {
    const hrs = +row.querySelector('.sport-hours').value;
    const met = +row.querySelector('.sport-met').value;
    sportH     += hrs;
    sportMETxH += met * hrs;
  });

  // energy expenditure
  const sleepH  = DEFAULT_SLEEP * 7;
  const passive = 168 - sleepH - workH - sportH;
  const bmr     = (10 * weight) + (6.25 * height) - (5 * age) + (gender === 'w' ? -161 : 5);
  const tdee    = bmr * ((0.95 * sleepH + jobMET * workH + sportMETxH + 1.75 * passive) / 168);

  // goal adjustment
  let target = tdee;
  if (goal === 'deficit') target = gender === 'w' ? tdee - 400 : tdee * 0.85;
  if (goal === 'surplus') target = gender === 'w' ? tdee + 200 : tdee + 250;

  // macros & bmi
  const bmi = weight / Math.pow(height / 100, 2);
  const pm  = bmi < 30 ? (goal === 'deficit' ? 2.2 : 1.7)
             : bmi < 35 ? (goal === 'deficit' ? 2.0 : 1.65)
             : bmi < 40 ? 1.35 : 1.2;

  const protein = weight * pm;                                    // total daily protein (g)
  const fat     = (gender === 'w' ? (bmi < 30 ? 0.30 : 0.35) : 0.25) * target / 9.3;
  const fiber   = ((gender === 'w' ? 16.7 : 13) * target) / 1000;
  const carbs   = (target - 4.1 * protein - 9.3 * fat - 2 * fiber) / 4.1;

  // kcal split
  const calP  = protein * 4.1;
  const calF  = fat     * 9.3;
  const calC  = Math.max(0, carbs) * 4.1;
  const calFi = fiber   * 2;
  const total = calP + calF + calC + calFi;
  const pct   = n => Math.round(n / total * 100);

  // shakes & equal meal distribution
  let shakes = 1;
  if (protein >= 160) shakes = 3;
  else if (protein >= 140) shakes = 2;

  // a) total protein - protein from shakes
  const otherProt = Math.max(0, protein - shakes * 20);

  // b) split equally between 3 meals
  const perMealProt = Math.round(otherProt / 3);

  breakfastCell.textContent = calcText('meal_protein', { amount: perMealProt });
  lunchCell.textContent     = calcText('meal_protein', { amount: perMealProt });
  dinnerCell.textContent    = calcText('meal_protein', { amount: perMealProt });
  shakesCell.textContent    = `${shakes}`;

  // protein source table
  document.getElementById('targetProteinCell').textContent = `${perMealProt}`;

  const gramsFor = p100 => Math.ceil((perMealProt / p100) * 100);
  document.getElementById('compShake').textContent = `${gramsFor(67)} g`;
  document.getElementById('compHarz' ).textContent = `${gramsFor(27)} g`;
  document.getElementById('compTuna' ).textContent = `${gramsFor(26)} g`;

  renderExtraSources(perMealProt);
  setupProteinToggle();

  // headline metrics
  document.getElementById('bmr')           .textContent = Math.round(bmr);
  document.getElementById('tdee')          .textContent = Math.round(tdee);
  document.getElementById('targetCalories').textContent = Math.round(target);
  document.getElementById('targetLabel')   .textContent = calcText('target');

  document.getElementById('protein').innerHTML =
    `${Math.round(protein)} g <span class="macro-pct">(${pct(calP)} %)</span>`;
  document.getElementById('fat').innerHTML =
    `${Math.round(fat)} g <span class="macro-pct">(${pct(calF)} %)</span>`;
  document.getElementById('carbs').innerHTML =
    `${Math.round(Math.max(0, carbs))} g <span class="macro-pct">(${pct(calC)} %)</span>`;
  document.getElementById('fiber').innerHTML =
    `${Math.round(fiber)} g <span class="macro-pct">(${pct(calFi)} %)</span>`;

  // BMI badge
  const bmiInfo = bmi < 18.5 ? [calcText('underweight'),'bmi-normal']
               : bmi < 25   ? [calcText('normal_weight'),'bmi-normal']
               : bmi < 30   ? [calcText('overweight'),'bmi-overweight']
               :              [calcText('obese'),'bmi-obese'];

  document.getElementById('bmi').textContent = bmi.toFixed(1);
  document.getElementById('bmiCategory').innerHTML =
    `<span class="bmi-indicator ${bmiInfo[1]}">(${calcEscape(bmiInfo[0])})</span>`;

  toggleCollection(true);

  // store for Klaviyo identify
  window.kcalcResult = {
    calories : Math.round(target),
    protein  : Math.round(protein),
    fat      : Math.round(fat),
    ballast  : Math.round(fiber),
    carbs    : Math.round(Math.max(0, carbs)),
    gender   : gender === 'w' ? 'female' : 'male',
    goal     : goal
  };
}

/* Event bindings */
genderBtns.forEach(btn => btn.onclick = () => {
  genderBtns.forEach(x => x.classList.remove('active'));
  btn.classList.add('active');
  gender = btn.dataset.gender;
  autoRecalc();
});

goalBtns.forEach(btn => btn.onclick = () => {
  goalBtns.forEach(x => x.classList.remove('active'));
  btn.classList.add('active');
  goal = btn.dataset.goal;
  autoRecalc();
});

addBtn.onclick    = () => addSportRow();
removeBtn.onclick = () => removeSportRow();
calcBtn.onclick   = () => { if (validateRequired()) { calculate(); togglePanels(); } };
editBtn.onclick   = () => { togglePanels(); toggleCollection(false); };

/* Init */
addSportRow(true);
if (collectionBox) collectionBox.classList.add('hidden');

/* Initialize NiceSelect2 for selects present on load (incl. #job) */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('select').forEach(el => {
    if (el.nextElementSibling && el.nextElementSibling.classList.contains('nice-select')) return;
    const placeholder = el.dataset.placeholder || (el.id === 'job' ? calcText('select_activity') : undefined);
    NiceSelect.bind(el, { searchable: false, placeholder });
  });

  setupProteinToggle();
});

/* Toggle collection visibility */
function toggleCollection(show){
  if (!collectionBox) return;
  collectionBox.classList.toggle('hidden', !show);
}

/* Masonry for success-grid + load more */
let msnry;
document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.grid');
  const isSuccessGridMobile = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
  if (grid && !isSuccessGridMobile) {
    function reorderForWideTiles(gridEl){
      const wide = [...gridEl.querySelectorAll('.grid-item--wide')];
      wide.forEach(el => {
        const idx  = [...el.parentElement.children].indexOf(el);
        const cols = 3;
        if (idx % cols === 0) return;
        const ref = gridEl.children[idx - (idx % cols)];
        ref.parentElement.insertBefore(el, ref);
      });
    }
    imagesLoaded(grid, () => {
      reorderForWideTiles(grid);
      msnry = new Masonry(grid, {
        itemSelector    : '.grid-item',
        columnWidth     : '.grid-sizer',
        gutter          : 24,
        percentPosition : true,
        fitWidth        : true,
        horizontalOrder : false
      });
    });
  }

  const wrap = document.querySelector('.success-grid__wrapper');
  if (wrap) {
    const items = wrap.querySelectorAll('.grid-item');
    if (items.length > 9) {
      wrap.classList.add('collapsed');
      const btn = document.createElement('button');
      btn.className = 'load-more-btn';
      btn.textContent = calcText('load_more');
      wrap.after(btn);
      btn.addEventListener('click', () => {
        wrap.classList.remove('collapsed');
        btn.remove();
        msnry && msnry.layout();
      });
    } else {
      wrap.classList.remove('collapsed');
    }
  }
});

/* sport hours +/- buttons */
sportWrap.addEventListener('click', e => {
  const btn = e.target.closest('.counter button');
  if (!btn) return;
  const row = btn.closest('.sport-input');
  const inp = row.querySelector('.sport-hours');
  if (inp.disabled) return;

  const step  = +(inp.step || 0.5);
  const delta = btn.classList.contains('inc') ? step : -step;
  changeHours(inp, delta);
});

/* FAQ accordion */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.Faq__Question').forEach(button => {
    button.addEventListener('click', () => {
      const item       = button.closest('.Faq__Item');
      const answerWrap = item.querySelector('.Faq__AnswerWrapper');
      const isOpen     = item.getAttribute('aria-expanded') === 'true';

      item.setAttribute('aria-expanded', String(!isOpen));
      answerWrap.setAttribute('aria-hidden',  String(isOpen));
    });
  });
});

/* SEO ToC auto-build */
document.addEventListener('DOMContentLoaded', () => {
  const seo = document.querySelector('.kcalc-seo');
  if (!seo) return;

  const toc = seo.querySelector('.kcalc-seo__contents__wrapper');
  const box = seo.querySelector('.kcalc-seo__content');
  if (!toc || !box) return;

  toc.innerHTML = '';
  box.querySelectorAll('h3').forEach((h3, i) => {
    const id = `anchor-${i+1}`;
    h3.id = id;

    const li = document.createElement('li');
    li.innerHTML = `<a href="#${id}">${h3.textContent.trim()}</a>`;
    toc.appendChild(li);
  });

  const HEADER_OFFSET = 150;

  toc.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (!link) return;

    e.stopImmediatePropagation();
    e.preventDefault();

    const target = document.querySelector(link.hash);
    if (!target) return;

    const y = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }, true);
});

/* Add discount code to product links */
document.addEventListener('DOMContentLoaded', () => {
  const productLinks = document.querySelectorAll('.CollectionEmbed.CollectionMain a[href]');

  productLinks.forEach(link => {
    const originalHref = link.getAttribute('href');
    if (!originalHref || originalHref.includes('/discount/START10')) return;

    let absoluteUrl;
    try {
      const u = new URL(originalHref, location.origin);
      absoluteUrl = u.pathname + u.search;
    } catch (e) {
      absoluteUrl = originalHref;
    }

    const discountUrl =
      'https://ruckanutrition.com/discount/START10?redirect=' +
      encodeURIComponent(absoluteUrl);

    link.setAttribute('href', discountUrl);
  });
});
